import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95ff0468"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-lg fs-sm" }, null, -1))
const _hoisted_2 = { class: "dropdown-content" }

import { computed } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DropButton',
  props: {
        title: String,
        btnClass: {
            type: String,
            default: 'btn-primary',
        },
        maxHeight: String,
        disabled: Boolean,
    },
  setup(__props) {

const props = __props;

    

    var classBtn = computed(() => {
        let c = '';
        if (props.btnClass) {
            c += props.btnClass;
        }
        if (props.disabled) {
            c += ' disabled';
        }
        return c;
    });

return (_ctx: any,_cache: any) => {
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ap-ddlb", { disabled: __props.disabled }])
  }, [
    _createVNode(_component_ap_button, {
      class: "ap-ddlb-btn w-100",
      "btn-class": _unref(classBtn),
      title: __props.title,
      disabled: __props.disabled
    }, {
      "icon-after": _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["btn-class", "title", "disabled"]),
    _createElementVNode("div", {
      class: "dropdown-content-wrapper",
      style: _normalizeStyle({ maxHeight: __props.maxHeight })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 4)
  ], 2))
}
}

})